<template>
    <div class="wrap">
        您已到期请联系客服人员续期
    </div>
</template>

<script>
    export default {
        data(){
            return {

            }
        }
    }
</script>

<style scoped lang="less">
.wrap{
    text-align: center;
    margin-top: 10vh;
    color: #333;
    font-size: 28px
}
</style>